import { render, staticRenderFns } from "./EditShipmentGovtModal.vue?vue&type=template&id=6089d1d8&"
import script from "./EditShipmentGovtModal.vue?vue&type=script&lang=js&"
export * from "./EditShipmentGovtModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports